export interface VacinacaoDirtyFieldsModel {
  imunobiologicos: Readonly<Set<string | undefined>>
  condicaoMaternal?: Readonly<string>
  outrasCondicoes: Readonly<string[]>
}

export type OutraCondicaoKey = 'viajante' | 'comunicanteHanseniase'

export type OutraCondicaoValue = 'Viajante' | 'Comunicante de Hanseníase'

export const outrasCondicoesVacinacaoRecord: Record<OutraCondicaoKey, OutraCondicaoValue> = {
  viajante: 'Viajante',
  comunicanteHanseniase: 'Comunicante de Hanseníase',
}
